import $ from "jquery";
import Storage from "@bd-utils/storage";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import { addDocument } from "@bd-core/firebase-actions";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { 
    getFinalTeamAnswers, 
    getRoomStartedAt, 
    getRoomStatus, 
    // getTeamAnswers
} from "@bd-stores/game-progress";
import {
    maybeUpdateRoomStatus,
    saveFinalRoomAnswers,
    setMiddleState,
    updateRoomAnswer,
} from "@bd-core/firebase-actions";


export class RoomMultipleQuestion extends BD_Component {
    constructor() {
        super();

        this.id = "multiple_question";
        this.templateID = "multiple_question-template";

        this.elms = {
            closeQuestion: ".js-multipleQuestions-close",
            openQuestion: ".js-multipleQuestions-open",
            questionPopup: ".js-questions-popup",
            booleanAnswer: ".js-boolean-answer",
            booleanItem: ".js-question",
            answers: ".js-answers",
            checkBtn: ".js-check",
            check: ".js-action",
            count: ".count",
            correct: ".js-correct",
            middle: ".js-middle",
            wrong: ".js-wrong",
            allCorrect: ".js-all-correct",
            roomStatus: ".js-room-status",
            background: ".js-screen-img",
            backgroundImage: ".screen__navigate",
            closeButtonPopup: ".multipleQuestions__close",
            backButton: ".app__back",

            pointerBtn: ".js-pointer",
            closePopupBtn: ".js-close-popup",
            imageBox: ".js-imagebox",
            imageBoxFullscreen: ".js-imagebox-fullscreen",
            openFullscreenBtn: ".js-open-imagebox-fullscreen",
            closeFullscreenBtn: ".js-close-popup-fullscreen",
            imageBoxImg: ".js-imagebox-img",
            shareBtn: ".js-share-btn",
            snackbar: ".js-saved-document-snackbar",
            closeSnackbar: ".js-close-snackbar",
            hintItems: ".js-hints-item",
            hintTimerBox: ".js-hint-timer-box",
            hintTimer: ".js-hint-timer",
            hintCounter: ".js-hint-counter",
        };

        this._events = this.getEvents();

        this.startX = 0;
        this.startY = 0;
        this.zoom = 100;
        this.hotspotSize = 25.5;
        this.isDown = false;
        this.hintInterval = null;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.openQuestion,
                handler: this.onQuestionToggler,
            },
            {
                event: "click",
                selector: elms.closeQuestion,
                handler: this.onQuestionToggler,
            },
            {
                event: "change",
                selector: elms.booleanAnswer,
                handler: this.onAnswerBoolean,
            },
            {
                event: "click",
                selector: elms.checkBtn,
                handler: this.onCheck,
            },
            {
                event: "click",
                selector: elms.pointerBtn,
                handler: this.onHandlePointer,
            },
            {
                event: "click",
                selector: elms.closePopupBtn,
                handler: this.onCloseImagePopup,
            },
            {
                event: "click",
                selector: elms.openFullscreenBtn,
                handler: this.handleFullscreen,
            },
            {
                event: "click",
                selector: elms.closeFullscreenBtn,
                handler: this.onCloseFullsceenPopup,
            },
            {
                event: "click",
                selector: elms.shareBtn,
                handler: this.onAddDocument,
            },
            {
                event: "click",
                selector: elms.closeSnackbar,
                handler: this.onCloseSnackbar,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.renderPlayRoom();
        this.setGameState();
    }

    getModifiedData() {
        const modified = { ...this._data };

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const docsHotspot = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "document",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const _hints = this._data.hints.map((hint, i) => {
            return {
                ...hint,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const _documents = this._data.documents.map((doc) => {
            const { document_id } = doc;
            const position = docsHotspot.find(
                (doc) => doc["document_id"] === document_id,
            );
            const position_top = position
                ? position["position_top"]
                : defaultValue;
            const position_left = position
                ? position["position_left"]
                : defaultValue;

            return {
                ...doc,
                position_top,
                position_left,
            };
        });

        const modifiedData = {
            ...modified,
            hints: _hints,
            documents: _documents,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        if (isForcedOpenChallenge) {
            this.onForceOppenChallenge();
        }
    }

    setGameState() {
        const elms = this.elms;
        const roomId = this.roomId;
        const roomAnswers = getFinalTeamAnswers(roomId);
        const thisRoomStatus = getRoomStatus(roomId);
        // const isTeamLeader = CONFIG.game.is_leader;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        // if(!isTeamLeader) {
        //     $(elms.booleanAnswer).prop("disabled", true);
        // }

        const setSelectedAnswers = function (answers) {
            $.each(answers, function (questionID, answer) {
                const $question = $(
                    elms.booleanItem + `[data-id="${String(questionID)}"]`,
                );

                $question.find(elms.booleanAnswer).prop("checked", answer);
            });
        };

        if (roomAnswers && Object.keys(roomAnswers).length) {
            setSelectedAnswers(roomAnswers);
        } else {
            // let tempAnswers = getTeamAnswers(roomId);

            //     if (Object.keys(tempAnswers).length) {
            //         tempAnswers = Object.values(tempAnswers)[0];
            //         setSelectedAnswers(tempAnswers);
            //         this.toggleCheckButton();
            //     } else {
                    //get individual answers from local storage
                    const individualAnswers = this.getSavedAnswers();
            
                    if (Object.keys(individualAnswers).length) {
                        setSelectedAnswers(individualAnswers);
                        this.toggleCheckButton();
                    }
                // }
        }

        if (thisRoomStatus == "is-status-completed") {
            if (!this.meSubmittingAnswer)
                $(elms.check).removeClass("is-checked");

            $(".check__result").addClass("is-shown");
            $(".js-all-correct").show().css("opacity", 1);
            $(elms.questionPopup).addClass("is-completed");
            $(".app__page").addClass("is-room-completed");
        }

        this.handleHintVisibility();
    }

    handleHintVisibility() {
        const elms = this.elms;
        const $hintItems = $(elms.hintItems);
        const hintCount = $hintItems.length;
        let currentHintIndex = 0;
        const $firstHint = $hintItems.first();
        let hintTimerToActive = Number($firstHint.attr("data-timer"));
        const roomStartedAt = getRoomStartedAt(this.roomId, CONFIG.user.id);
        if(!roomStartedAt) return;

        if(hintCount === 0) return;

        if(this.hintInterval) {
            clearInterval(this.hintInterval);
            this.hintInterval = null;
        }

        const checkHints = () => {
            const now = Date.now();
            const minutesPassed = Math.floor((now - roomStartedAt) / 60000); //convert ms to minutes
            // let hintActiveId = null;

            $hintItems.each(function (index) {
                const $this = $(this);
                const hintTimer = Number($this.attr("data-timer"));
                if(minutesPassed >= hintTimer) {
                    // $hintItems.addClass("hidden");
                    $this.removeClass("hidden");
                    // hintActiveId = $this.attr("data-id");
                    const $nextHint = $this.next();
                    hintTimerToActive = $nextHint.length ? Number($nextHint.attr("data-timer")) : 0;
                    currentHintIndex = index + 1;
                }
            });

            if(hintTimerToActive > 0) {
                const nextHintTimer = hintTimerToActive;
                const nextHintTimerInMs = (nextHintTimer * 60000 + roomStartedAt) - now;
                const minutesToNextHint = Math.floor(nextHintTimerInMs / 60000);
                const secondsToNextHint = Math.floor((nextHintTimerInMs % 60000) / 1000);
                const minutesTxt = minutesToNextHint < 10 ? `0${minutesToNextHint}` : minutesToNextHint;
                const secondsTxt = secondsToNextHint < 10 ? `0${secondsToNextHint}` : secondsToNextHint;
                const nextHintTimerText =  `${minutesTxt}:${secondsTxt}`;

                $(elms.hintTimer).text(nextHintTimerText);
            }

            const nextHintCounter = `${currentHintIndex}/${hintCount}`;
            $(elms.hintCounter).text(nextHintCounter);

            // if last hint, hide timer box and clear interval
            if(currentHintIndex === hintCount) {
                $(elms.hintTimerBox).addClass("hidden");
                clearInterval(this.hintInterval);
            }
        }

        // Run immediately on page load
        checkHints();

        // Run every seconds
        this.hintInterval = setInterval(checkHints, 1000);
    }

    renderPlayRoom() {
        const startedAt = +new Date();
        const $playroom = $(".playroom").last();
        const $playroomImage = $playroom.find(".playroom-image");
        const $playroomWrapper = $playroom.find(".playroom-wrapper");

        if (!$playroom) return;

        // show error if onLoad not called more than 10s
        const waitLoad = setInterval(() => {
            const now = +new Date();
            const diff = now - startedAt;
            if (diff > 10 * 1000) {
                // showMessage(viewData.strings.playroom_image_error_load);
                clearInterval(waitLoad);
            }
        }, 100);

        const calculate = () => {
            const imageRatio = $playroomImage.height() / $playroomImage.width();
            const containerRatio = $playroom.height() / $playroom.width();

            let finalHeight;
            let finalWidth;

            if (containerRatio > imageRatio) {
                finalHeight = $playroom.height();
                finalWidth = $playroom.height() / imageRatio;
            } else {
                finalWidth = $playroom.width();
                finalHeight = $playroom.width() * imageRatio;
            }

            $playroomWrapper.css({
                height: finalHeight + "px",
                width: finalWidth + "px",
            });

            $playroomImage.css({
                height: finalHeight + "px",
                width: finalWidth + "px",
            });

            $playroom.addClass("is-calculated");
        };

        const markAsLoaded = () => {
            clearInterval(waitLoad);
        };

        const onLoad = () => {
            calculate();
            markAsLoaded();
        };

        // if image loaded directly from cached file, it wont trigger onload
        // @ts-ignore
        // if ($playroomImage[0].complete) onLoad();
        $playroomImage.on("load", onLoad);
    }

    // ============================== CUSTOM FUNCTION

    /**
     * Decide whether to disabled or enabled boolean action (Check btn)
     */
    toggleCheckButton() {
        const elms = this.elms;
        let hasAnswer = false;
        // const isTeamLeader = CONFIG.game.is_leader;

        // if(!isTeamLeader) {
        //     $(elms.checkBtn).prop("disabled", true);
        //     return;
        // }

        $(elms.booleanItem).each(function () {
            const $answer = $(this).find(elms.booleanAnswer);
            const checked = $answer.prop("checked");

            if (checked) {
                hasAnswer = true;
                return false; // break the loop
            }
        });

        $(elms.checkBtn).prop("disabled", !hasAnswer);
    }

    getSavedAnswers() {
        const roomID = this.roomId;
        const states = Storage.get("states", {});
        const savedAnswers = states?.answers?.[roomID] || {};

        return savedAnswers;
    }

    setSavedAnswers(answers) {
        const roomID = this.roomId;
        let states = Storage.get("states", {});
        if (!states?.answers) states.answers = {};
        if (!states?.answers?.[roomID]) states.answers[roomID] = {};
        states.answers[roomID] = answers;

        return Storage.set("states", states);
    }

    /**
     * Save answer for particular questionId into local storage
     * @param {string} questionId
     * @param {string | boolean} value
     */
    saveAnswer(questionId, value) {
        let savedAnswers = this.getSavedAnswers();
        savedAnswers[questionId] = value;
        this.setSavedAnswers(savedAnswers);
        this.updateUserAnswer(savedAnswers);
    }

    onAnswerBoolean(e, el) {
        const $this = $(el);
        const elms = this.elms;
        const $boolean = $this.parents(elms.questionPopup);

        if ($boolean.hasClass("is-completed")) {
            return false;
        }

        //save the answer into local storage
        const questionID = $this.attr("data-question-id");
        const checked = $this.prop("checked");
        this.saveAnswer(questionID, checked);
        this.toggleCheckButton();
    }

    onCheck(e, el) {
        const elms = this.elms;
        const $el = $(el);
        // const isTeamLeader = CONFIG.game.is_leader;

        // if(!isTeamLeader) {
        //     return;
        // }

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        $el.parent().removeClass("is-checked");
        $el.addClass("is-loading").prop("disabled", true);

        const roomID = this.roomId;
        let roomStatus = "is-status-started";
        let roomAnswers = getRoomAnswerById(roomID);
        let playerAnswers = [];
        let correct_count = 0;
        let middle_count = 0;
        let wrong_count = 0;
        let isMiddleState = false;

        $(elms.booleanItem).each(function () {
            const $item = $(this);
            const questionID = $item.attr("data-id");
            const $answer = $item.find(elms.booleanAnswer);
            const isTrue = $answer.prop("checked");

            playerAnswers[questionID] = isTrue;
        });

        for (const key in playerAnswers) {
            if (playerAnswers[key] === roomAnswers[key]) {
                correct_count++;
            } else {
                wrong_count++;
            }
        }

        const isAllCorrect =
            wrong_count === 0 &&
            correct_count === Object.keys(roomAnswers).length;

        if (isAllCorrect) {
            roomStatus = "is-status-completed";
            this.meSubmittingAnswer = true; // a flag to set the UI state

            if (isMiddleState) setMiddleState(roomID);

            const onSuccess = () => {
                $el.parent().addClass("is-completed");
                $el.parents(elms.questionPopup).addClass("is-completed");
                $(elms.allCorrect).find(".count").text("All Correct");
                $(elms.correct).hide();
                $(elms.wrong).hide();
                $(elms.allCorrect).show().css("opacity", 1);
            };

            saveFinalRoomAnswers(roomID, playerAnswers)
                .then(onSuccess)
                .catch(() => (this.meSubmittingAnswer = false));
        }

        $el.parent().addClass("is-checked");
        $(elms.correct).find(".count").text(correct_count);
        $(elms.middle).find(".count").text(middle_count);
        $(elms.wrong).find(".count").text(wrong_count);

        $el.removeClass("is-loading").removeAttr("disabled");

        setTimeout(() => {
            maybeUpdateRoomStatus(roomID, roomStatus);
        }, 3500);
    }

    onQuestionToggler() {
        const elms = this.elms;
        const hasOpen = $(elms.questionPopup).hasClass("is-open");
        const isOpened = !hasOpen;
        const blur = $(".app-blur");

        blur.toggleClass("is-blurred", isOpened);
        $(elms.questionPopup).toggleClass("is-open", isOpened);
    }

    onForceOppenChallenge() {
        const elms = this.elms.questionPopup;
        const closeButton = this.elms.closeButtonPopup;
        const backButton = this.elms.backButton;

        const blur = $(".app-blur");

        blur.addClass("is-blurred");

        $(elms).addClass("is-open");
        $(closeButton).addClass("hidden");
        $(backButton).addClass("up-front");
    }

    updateUserAnswer(answers) {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        updateRoomAnswer(roomId, {
            [currentPlayerId]: answers,
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const questionID = hasContext
                ? $context.attr("data-question-id")
                : undefined;
            const questionAnswerID = hasContext
                ? $context.attr("data-answer-id")
                : undefined;

            const users = onlinePlayers.filter((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "object") {
                    return;
                }

                if (thisPlayerAnswer[questionID] == questionAnswerID) {
                    return player;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }

    onHandlePointer(e) {
        const elms = this.elms;
        const $this = $(e.currentTarget);
        const $imagebox = $(elms.imageBox);
        const $title = $(".playroom-imagebox-title");
        const $description = $(".playroom-imagebox-description");
        const $image = $(".playroom-imagebox-image");
        const title = $this.attr("data-title");
        const docId = $this.attr("data-id");
        const description = $this.data("description");
        const image = $this.data("image");
        const isFullscreen = $this.hasClass("is-fullscreen");
        const newImage = new Image();

        // This is to determine whether tutorial can be shown or not
        // because Tutorial should only be open only if $imagebox is open
        // and $image has been loaded successfully
        // `I` stands for `imagebox`
        // let hasIOpened = false;
        // let hasILoaded = false;

        // const onFinishTransition = () => {
        //     // Prevent prematurely show tutorial when the email hasn't open yet
        //     if (!$imagebox.hasClass('is-open')) return false;

        //     hasIOpened = true;
        //     // showTutorial();
        // };

        // const transitionEndEvent = getTransitionEndEvent();
        // $imagebox.on(transitionEndEvent, onFinishTransition);

        newImage.src = image;
        newImage.onload = function () {
            $image.removeClass("is-loading");
            // hasILoaded = true;
            // showTutorial();
        };

        if (isFullscreen) {
            $imagebox.addClass("is-fullscreen");
        } else {
            $imagebox.removeClass("is-fullscreen");
        }

        $title.html(title);
        $description.html(description);
        $image.find("img").remove();
        $image.addClass("is-loading").append(newImage);
        $imagebox.addClass("is-open");

        $(elms.shareBtn).attr("data-id", docId);
        $(elms.shareBtn).attr("data-url", image);
        $(elms.shareBtn).attr("data-title", title);

        if (
            title.toLowerCase() == "ceo's laptop" ||
            title.toLowerCase() == "chairwoman's laptop"
        ) {
            $imagebox.addClass("is-ceo-laptop");
        } else {
            $imagebox.removeClass("is-ceo-laptop");
        }
    }

    onCloseImagePopup() {
        $(this.elms.imageBox).removeClass("is-open");
    }

    handleFullscreen() {
        const elms = this.elms;
        const $selectedImg = $(elms.imageBoxImg).find("img");
        const $imageboxFullscreen = $(elms.imageBoxFullscreen);
        const $fullscreenWrapper = $imageboxFullscreen.find(
            ".popup-fullscreen-wrapper",
        );
        const $existingImg = $fullscreenWrapper.find("img");

        if ($existingImg.length) {
            $existingImg.removeClass("is-active");
            $existingImg.remove();
        }

        $selectedImg
            .clone(true)
            .addClass("is-active")
            .appendTo($fullscreenWrapper);
        $imageboxFullscreen.addClass("is-open");
    }

    onCloseFullsceenPopup() {
        const elms = this.elms;
        const $imageboxFullscreen = $(elms.imageBoxFullscreen);
        $imageboxFullscreen.removeClass("is-open");
    }

    onAddDocument(e) {
        const $this = $(e.currentTarget);
        const id = $this.attr("data-id");
        const url = $this.attr("data-url");
        const title = $this.attr("data-title");
        const type = "image";

        const docObj = {
            [id]: {
                url,
                title,
                type,
            },
        };

        addDocument(docObj)
            .then(() => {
                $(".js-saved-document-snackbar").addClass("is-open");
                setTimeout(() => {
                    $(".js-saved-document-snackbar").removeClass("is-open");
                }, 3000);
            })
            .catch(() => console.error("failed"));
    }

    onCloseSnackbar() {
        $(this.elms.snackbar).removeClass("is-open");
    }

    beforeDestroy() {
        if(this.hintInterval) clearInterval(this.hintInterval);
    }
}
